import { useState, forwardRef } from "react";

/**
 *
 * @param {object} param0
 * @param {JSX.Element} [param0.children]
 * @param {"center"|"flex-start"|"flex-end"|"space-between"|"space-around"} [param0.justifyContent]
 * @param {"center"|"flex-start"|"flex-end"|"space-between"|"space-around"} [param0.alignItems]
 * @param {function} [param0.onClick]
 * @param {function} [param0.onMouseEnter]
 * @param {function} [param0.onMouseLeave]
 * @param {boolean} [param0.hide]
 * @param {object} [param0.style]
 * @param {JSX.Element} [param0.hoverMenu] - 悬停时显示的菜单内容
 * @param {"top"|"bottom"|"left"|"right"} [param0.menuPosition] - 菜单位置，默认为 "bottom"
 * @returns
 */
const DivInline = forwardRef(function DivInline({
  children,
  justifyContent,
  alignItems,
  onClick,
  onContextMenu,
  onMouseEnter,
  onMouseLeave,
  hide,
  style,
  sx,
  hoverMenu,
  menuPosition = "bottom",
}, ref) {
  const [showMenu, setShowMenu] = useState(false);

  if (hide) return null;

  const handleMouseEnter = (e) => {
    if (hoverMenu) {
      setShowMenu(true);
    }
    if (onMouseEnter) {
      onMouseEnter(e);
    }
  };

  const handleMouseLeave = (e) => {
    if (hoverMenu) {
      setShowMenu(false);
    }
    if (onMouseLeave) {
      onMouseLeave(e);
    }
  };

  const getMenuStyle = () => {
    const baseStyle = {
      position: "absolute",
      zIndex: 1000,
      backgroundColor: "white",
      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
      borderRadius: "4px",
      padding: "4px 0",
      minWidth: "120px",
      marginTop: menuPosition === "bottom" ? "4px" : undefined,
      marginBottom: menuPosition === "top" ? "4px" : undefined,
      marginLeft: menuPosition === "right" ? "4px" : undefined,
      marginRight: menuPosition === "left" ? "4px" : undefined,
    };

    switch (menuPosition) {
      case "top":
        return { ...baseStyle, bottom: "100%" };
      case "left":
        return { ...baseStyle, right: "100%" };
      case "right":
        return { ...baseStyle, left: "100%" };
      case "bottom":
      default:
        return { ...baseStyle, top: "100%" };
    }
  };

  return (
    <div
      ref={ref}
      style={{
        display: "flex",
        alignItems: alignItems || "center",
        justifyContent: justifyContent || "flex-start",
        cursor: onClick ? "pointer" : "default",
        position: hoverMenu ? "relative" : undefined,
        ...style,
        ...sx,
      }}
      onClick={onClick}
      onContextMenu={(e) => { if (onContextMenu) onContextMenu(e) }}
      onMouseLeave={handleMouseLeave}
      onMouseEnter={handleMouseEnter}
    >
      {children}
      {hoverMenu && showMenu && (
        <div
          style={getMenuStyle()}
          onMouseEnter={() => setShowMenu(true)}
          onMouseLeave={() => setShowMenu(false)}
        >
          {hoverMenu}
        </div>
      )}
    </div>

  );
});

export default DivInline;
